import React from 'react';
import { XIcon } from 'lucide-react';
interface ImpressumProps {
  onClose: () => void;
}
export function Impressum({
  onClose
}: ImpressumProps) {
  return <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4" data-id="element-488">
      <div className="bg-white rounded-xl shadow-lg max-w-2xl w-full max-h-[90vh] overflow-hidden flex flex-col" data-id="element-489">
        <div className="p-4 border-b border-gray-200 flex justify-between items-center" data-id="element-490">
          <h2 className="text-xl font-bold text-gray-800" data-id="element-491">Impressum</h2>
          <button onClick={onClose} className="text-gray-500 hover:text-gray-700" data-id="element-492">
            <XIcon size={20} data-id="element-493" />
          </button>
        </div>
        <div className="overflow-y-auto p-6 flex-grow" data-id="element-494">
          <h3 className="text-lg font-semibold mb-2" data-id="element-495">Angaben gemäß § 5 TMG</h3>
          <p className="mb-4" data-id="element-496">
            INTIGOO! GmbH
            <br data-id="element-497" />
            Werner-von-Siemens-Straße 33
            <br data-id="element-498" />
            49124 Georgsmarienhütte
          </p>
          <p className="mb-4" data-id="element-499">
            <strong data-id="element-500">Handelsregister:</strong> HRB 217224
            <br data-id="element-501" />
            <strong data-id="element-502">Registergericht:</strong> Amtsgericht Osnabrück
          </p>
          <p className="mb-4" data-id="element-503">
            <strong data-id="element-504">Vertreten durch:</strong>
            <br data-id="element-505" />
            Fabian Kleine Huxel
            <br data-id="element-506" />
            Felix Höfelmeyer
          </p>
          <h3 className="text-lg font-semibold mb-2" data-id="element-507">Kontakt</h3>
          <p className="mb-4" data-id="element-508">
            <strong data-id="element-509">Telefon:</strong> +49 5401 1689580
            <br data-id="element-510" />
            <strong data-id="element-511">E‑Mail:</strong> info@intigoo.de
          </p>
          <h3 className="text-lg font-semibold mb-2" data-id="element-512">Umsatzsteuer-ID</h3>
          <p className="mb-4" data-id="element-513">
            <strong data-id="element-514">
              Umsatzsteuer-Identifikationsnummer gemäß § 27 a
              Umsatzsteuergesetz:
            </strong>
            <br data-id="element-515" />
            DE 349819653
          </p>
          <h3 className="text-lg font-semibold mb-2" data-id="element-516">EU-Streitschlichtung</h3>
          <p className="mb-4" data-id="element-517">
            Die Europäische Kommission stellt eine Plattform zur
            Online-Streitbeilegung (OS) bereit:
            https://ec.europa.eu/consumers/odr/. Unsere E‑Mail-Adresse finden
            Sie oben im Impressum.
          </p>
          <h3 className="text-lg font-semibold mb-2" data-id="element-518">
            Verbraucherstreitbeilegung / Universalschlichtungsstelle
          </h3>
          <p className="mb-4" data-id="element-519">
            Wir sind nicht bereit oder verpflichtet, an
            Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle
            teilzunehmen.
          </p>
        </div>
        <div className="p-4 border-t border-gray-200 flex justify-end" data-id="element-520">
          <button onClick={onClose} className="px-4 py-2 bg-gray-200 hover:bg-gray-300 text-gray-800 rounded-md" data-id="element-521">
            Schließen
          </button>
        </div>
      </div>
    </div>;
}